<template lang="pug">
  b-modal(v-model="loading" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer)
    .loading-msg
      b-spinner.spinner
      .message.align-self-center {{ value }}／{{ max }} {{ message }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * プログレスつきローディング表示コンポーネント
 *
 * ローディングの表示/非表示を切り替える
 */
@Component
export default class ProgressLoading extends Vue {
  /** プログレス現在値 */
  @Prop({ required: true })
  value!: number;
  /** プログレス最大値 */
  @Prop({ required: true })
  max!: number;
  /** ローディングの表示 */
  @Prop({ required: true })
  loading!: boolean;
  /** 表示メッセージ */
  @Prop({ default: "" })
  message!: string;

  /** Propで渡された値は直接templateで参照しないようにするため、getで渡す */
  get _value(): number {
    return this.value;
  }

  /**
   *  vue lifecycle created
   */
  public created(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/mobile/_colors.scss";

.loading-msg {
  text-align: center;
  padding: 2rem 0;
  .spinner {
    color: $loding-spinner;
    width: 30px;
    height: 30px;
    margin-right: 6px;
  }
  .message {
    color: $font-base;
    font-size: 1.4rem;
    font-weight: bold;
  }
}
</style>
